// Non-secret "has session" cookie. The server reads it in app/page.jsx to pick
// the correct shell (Studio vs Landing) before the first byte ships, so returning
// users don't flash Landing on refresh. Holds no tokens or identifiers — the real
// session lives in Auth0's localStorage cache and on Auth0's side.
export const SESSION_COOKIE = "qk_has_session";
const MAX_AGE_SECONDS = 60 * 60 * 24 * 30; // 30 days

export function setHasSessionCookie() {
  if (typeof document === "undefined") return;
  const secure = typeof window !== "undefined" && window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${SESSION_COOKIE}=1; Path=/; Max-Age=${MAX_AGE_SECONDS}; SameSite=Lax${secure}`;
}

export function clearHasSessionCookie() {
  if (typeof document === "undefined") return;
  const secure = typeof window !== "undefined" && window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${SESSION_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax${secure}`;
}
